function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * @file 拦截xmlhttprequest对象
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util / interceptAjax
 */
import timeReport from '../time';
import { Config, HB_SESSION_ID_KEY, trackID, getUserID, DISABLE_INTERCEPT_API_DOAMIN_LIST } from './config';
import extractPathname from './url';
import cookie from './cookie';
import Stack from './stack';
var BACKEND_API_GAPM_TRACEID = 'gapm-traceid';
// 全局取一次就好
var documentWidth = 0;
var documentHeight = 0;
var HB_SESSION_ID_VALUE = cookie.get(HB_SESSION_ID_KEY);
var requestStack = new Stack(20);
function clearBufferSize(event) {
  var _performance;
  (_performance = performance) === null || _performance === void 0 ? void 0 : _performance.clearResourceTimings();
}
function canMakeHTTPRequest() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
}
function isPositiveNumber(value) {
  return typeof value === 'number' && value > 0;
}

/**
 * 校验请求链接是否命中规则
 *
 * @param {string} 需要进行判断的url
 * @param {string} 需要校验的规则
 * @return {boolean} 是否命中规则
 */
function canUrlIntercept(url, rule) {
  if (typeof rule === 'string') {
    return url.includes(rule);
  }
  if (rule instanceof RegExp) {
    return rule.test(url);
  }
  return false;
}

/**
 * 是否可以拦截当前域名接口， 除了 DISABLE_INTERCEPT_API_DOAMIN_LIST 之外，都需要拦截一下
 *
 * @param {string} 需要进行判断的url
 * @return {boolean} 是否不能拦截某些接口
 */
function canNotIntercept() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // 多取几次appNid是为了兼容历史传参情况
  var appNid = Config.APPNID || Config.appNid || Config.appId;
  // 开关打开时且有appNid才允许拦截
  if (!Config.ALLOW_INTERCEPT || !appNid) {
    return true;
  }
  try {
    var _Config$INTERCEPT_RUL = Config.INTERCEPT_RULES,
      _Config$INTERCEPT_RUL2 = _Config$INTERCEPT_RUL.include,
      include = _Config$INTERCEPT_RUL2 === void 0 ? [] : _Config$INTERCEPT_RUL2,
      _Config$INTERCEPT_RUL3 = _Config$INTERCEPT_RUL.exclude,
      exclude = _Config$INTERCEPT_RUL3 === void 0 ? [] : _Config$INTERCEPT_RUL3;
    // 优先校验黑明单，第一优先级，符合黑名单规则的不上报
    if ([].concat(_toConsumableArray(DISABLE_INTERCEPT_API_DOAMIN_LIST), _toConsumableArray(exclude)).some(function (rule) {
      return canUrlIntercept(url, rule);
    })) {
      return true;
    }
    // 如果未配置白名单，则上报非黑明单的所有url
    if (include.length === 0) {
      return false;
    }
    // 如果配置了白名单，则上报非黑明单且只在白名单的url
    if (include.some(function (rule) {
      return canUrlIntercept(url, rule);
    })) {
      return false;
    }
    return true;
  } catch (e) {
    throw new Error(e.message);
  }
}

/**
 * 拦截接口请求，执行自定义的回调
 *
 * @param {Function} fn 回调函数
 */
export function interceptXHR(fn) {
  if (canMakeHTTPRequest()) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function xhropen() {
      var _this = this;
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }
      var start = Date.now();
      var _params$ = params[1],
        url = _params$ === void 0 ? '' : _params$;
      if (canNotIntercept(url)) {
        open.apply(this, params);
      } else {
        var readyStateChangeListener = function readyStateChangeListener() {
          /**
           * 性能考虑，只有在xhr状态为 DONE 时，才进行后续的拦截上报操作。
           *
           * UNSENT（未发送）0
           * OPENED（已打开）1
           * HEADERS_RECEIVED () 2
           * LOADING（下载中）3
           * DONE（完成）4
           */
          // 为防止其他第三方脚本修改 XMLHttpRequest，比如oneapm，再从原型上取一下值
          if (_this.readyState === XMLHttpRequest.DONE || _this.readyState === XMLHttpRequest.prototype.DONE) {
            var elapsed = Date.now() - start;
            if (canNotIntercept(url)) {
              _this.removeEventListener('readystatechange', readyStateChangeListener);
              return;
            }

            // 将当前xhr 实例， open 方法的所有参数，和额外的数据（比如性能耗时信息，以后可以继续补充）传给回调函数
            if (typeof fn === 'function') {
              try {
                fn(_this, params, {
                  start: start,
                  elapsed: elapsed
                });
              } catch (e) {
                // eslint-disable-next-line no-console
                console.error('interceptXHR err', e);
              }
            }
            _this.removeEventListener('readystatechange', readyStateChangeListener);
          }
        };
        this.addEventListener('readystatechange', readyStateChangeListener);
        open.apply(this, params);
      }
    };
  }
}

/**
 * 拦截fetch接口请求
 *
 * @param {Function} fn 处理fetch返回结果的回调函数
 */
export function interceptFetch(fn) {
  if (canMakeHTTPRequest()) {
    var oldFetch = fetch;
    window.fetch = function newfetch() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var start = Date.now();
      return oldFetch.apply(null, args).then(function (fetchResponse) {
        // 请求结束之后计时，防止产生较大误差
        var elapsed = Date.now() - start;
        fn(fetchResponse, args, {
          start: start,
          elapsed: elapsed
        });
        return fetchResponse;
      }, function (fetchResponse) {
        // 请求结束之后计时，防止产生较大误差
        var elapsed = Date.now() - start;
        // 接口由于网络失败，或者中断请求
        fn(fetchResponse, args, {
          start: start,
          elapsed: elapsed
        });
        return fetchResponse;
      });
    };
  }
}
function getEntry(url, startTime) {
  var _performance2, _performance3, _performance4;
  var navigationStart = ((_performance2 = performance) === null || _performance2 === void 0 ? void 0 : _performance2.timeOrigin) || 0;
  // 距离页面时间原点已过去*毫秒
  var timeElapsed = ((_performance3 = performance) === null || _performance3 === void 0 ? void 0 : _performance3.now()) || 0;
  var timeDifference = Date.now() - navigationStart - timeElapsed;
  var len = requestStack.display().length;
  for (var i = len; i > 0; i--) {
    var _entry = requestStack.display()[i - 1];
    var _entryStartTime = navigationStart && _entry.startTime && Math.round(navigationStart + _entry.startTime);
    var _difference = Math.abs(startTime - _entryStartTime - timeDifference);
    if (_entry.name === url && _difference >= 0 && _difference < 5) {
      return _entry;
    }
  }
  var performanceResourceTimings = ((_performance4 = performance) === null || _performance4 === void 0 ? void 0 : _performance4.getEntriesByName(url)) || [];
  var entry = performanceResourceTimings[performanceResourceTimings.length - 1] || {};
  var entryStartTime = navigationStart && (entry === null || entry === void 0 ? void 0 : entry.startTime) && Math.round(navigationStart + entry.startTime);
  var difference = Math.abs(startTime - entryStartTime - timeDifference);
  if (difference >= 0 && difference < 5) {
    return entry;
  }
  return null;
}
function getBaseData(entry, navigationStart, timeDifference) {
  var _navigator, _navigator$connection;
  var duration = entry.duration,
    startTime = entry.startTime;
  return {
    start: navigationStart && startTime && Math.round(navigationStart + startTime + timeDifference),
    duration: duration === null || duration === void 0 ? void 0 : duration.toFixed(2),
    rtt: ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$connection = _navigator.connection) === null || _navigator$connection === void 0 ? void 0 : _navigator$connection.rtt) || -1
  };
}
function getTimeData(entry) {
  var startTime = entry.startTime,
    domainLookupStart = entry.domainLookupStart,
    domainLookupEnd = entry.domainLookupEnd,
    connectStart = entry.connectStart,
    connectEnd = entry.connectEnd,
    fetchStart = entry.fetchStart,
    responseStart = entry.responseStart,
    requestStart = entry.requestStart,
    responseEnd = entry.responseEnd;
  return {
    startTime: startTime === null || startTime === void 0 ? void 0 : startTime.toFixed(2),
    domainLookupStart: domainLookupStart === null || domainLookupStart === void 0 ? void 0 : domainLookupStart.toFixed(2),
    domainLookupEnd: domainLookupEnd === null || domainLookupEnd === void 0 ? void 0 : domainLookupEnd.toFixed(2),
    connectStart: connectStart === null || connectStart === void 0 ? void 0 : connectStart.toFixed(2),
    connectEnd: connectEnd === null || connectEnd === void 0 ? void 0 : connectEnd.toFixed(2),
    fetchStart: fetchStart === null || fetchStart === void 0 ? void 0 : fetchStart.toFixed(2),
    responseStart: responseStart === null || responseStart === void 0 ? void 0 : responseStart.toFixed(2),
    requestStart: requestStart === null || requestStart === void 0 ? void 0 : requestStart.toFixed(2),
    responseEnd: responseEnd === null || responseEnd === void 0 ? void 0 : responseEnd.toFixed(2)
  };
}
function getSizeData(entry) {
  var encodedBodySize = entry.encodedBodySize,
    decodedBodySize = entry.decodedBodySize,
    transferSize = entry.transferSize;
  return {
    encodedBodySize: encodedBodySize,
    decodedBodySize: decodedBodySize,
    transferSize: transferSize
  };
}

/**
 * 为给定的URL获取性能资源计时。 从performance.getEntriesByName中获取
 * @param {string} url 请求api（protocal+domain+path+query）
 * @param {Array} types 获取{base: false, times: false, size: false}中的性能资源计时信息类型
 * @returns {Object} - 包含性能资源计时信息的对象。
 */
function getPerformanceResourceTiming() {
  var _performance5, _performance6;
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var startTime = arguments.length > 1 ? arguments[1] : undefined;
  var types = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    base: false,
    times: false,
    size: false
  };
  var entry = getEntry(url, startTime);
  if (!entry || !types) {
    return {
      base: {},
      times: {},
      size: {}
    };
  }
  var navigationStart = ((_performance5 = performance) === null || _performance5 === void 0 ? void 0 : _performance5.timeOrigin) || 0;
  var timeElapsed = ((_performance6 = performance) === null || _performance6 === void 0 ? void 0 : _performance6.now()) || 0;
  var timeDifference = Date.now() - navigationStart - timeElapsed;
  return {
    base: types.base ? getBaseData(entry, navigationStart, timeDifference) : {},
    times: types.times ? getTimeData(entry) : {},
    size: types.size ? getSizeData(entry) : {}
  };
}

/**
 * 拦截 XHR 接口请求后，执行自定义的回调
 *
 * @param {Object} xhrInstance XHR实例对象
 * @param {Array.<string>} apiParams 发起请求时带的参数
 * @param {number} elapsed 接口请求的耗时
 */
function handleXHR(xhrInstance, apiParams, _ref) {
  var start = _ref.start,
    elapsed = _ref.elapsed;
  // gapm traceid 是后端返回的用来跟踪每次接口请求链路的id，放在api接口的响应头里，往轻舟发起 api_call 类型请求的时候自动带上
  var apiCallTraceId = '';

  // 提前判断一下响应头是否存在 BACKEND_API_GAPM_TRACEID，如果不存在，还用 getResponseHeader 获取，chrome上就会在控制台报错，但是这个错误不影响代码后续执行
  if (xhrInstance.getAllResponseHeaders().indexOf(BACKEND_API_GAPM_TRACEID) > -1) {
    apiCallTraceId = xhrInstance.getResponseHeader(BACKEND_API_GAPM_TRACEID);
  }
  var _getPerformanceResour = getPerformanceResourceTiming(xhrInstance.responseURL, start, {
      base: true
    }),
    base = _getPerformanceResour.base;

  // 要上报的数据
  var timingData = _objectSpread(_objectSpread({}, getBasicApiTimeData()), {}, {
    // 操作名，一般取接口路径 params为发起xhr 请求时，OPEN方法的所有参数
    // 举个例子 apiParams = ['GET', '/api/1', true]， apiParams[1] 就是请求的接口，过滤掉接口的query 部分
    actionName: extractPathname(apiParams[1]),
    actionStart: base.start || start,
    // 接口耗时 自己计算的elapsed作为备份数据
    elapsed: base.duration || elapsed,
    // 接口状态
    code: xhrInstance.status,
    // 每次接口请求都会改变，
    betraceid: apiCallTraceId
  });

  // 接口总时长大于*ms
  if (isPositiveNumber(Config.SLOW_REQUEST_THRESHOLD) && base.duration > Config.SLOW_REQUEST_THRESHOLD) {
    var _getPerformanceResour2 = getPerformanceResourceTiming(xhrInstance.responseURL, start, {
        times: true,
        size: true
      }),
      times = _getPerformanceResour2.times,
      size = _getPerformanceResour2.size;
    Object.assign(timingData, {
      // PerformanceResourceTiming
      prt: JSON.stringify(_objectSpread(_objectSpread(_objectSpread({}, times), size), {}, {
        rtt: base.rtt
      }))
    });
  }
  if (xhrInstance.status >= 400) {
    var responseText = xhrInstance.responseText;
    var resData = {};
    try {
      resData = JSON.parse(responseText);
    } catch (error) {}
    Object.assign(timingData, {
      success: false,
      reponse: resData.data || responseText,
      request: JSON.stringify(apiParams),
      msg: resData.msg
    });
  }
  timeReport(timingData);
}

/**
 * 获取上报数据
 *
 * @param {Object} fetchResponse fetch响应的实例
 * @param {Object} apiParams fetch请求的参数对象
 * @param {number} start fetch请求起始时间戳
 * @param {Object} resData 解析接口响应的json数据
 * @param {Error} jsonErr 解析json出错Error对象
 */
function reportPerfData(fetchResponse, apiParams, start) {
  var elapsed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var resData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var jsonErr = arguments.length > 5 ? arguments[5] : undefined;
  var apiCallTraceId = fetchResponse.headers.get(BACKEND_API_GAPM_TRACEID);
  var url = fetchResponse.url,
    ok = fetchResponse.ok,
    status = fetchResponse.status;
  // 在最终拿到返回的json后结束计时

  var _getPerformanceResour3 = getPerformanceResourceTiming(fetchResponse.url, start, {
      base: true
    }),
    base = _getPerformanceResour3.base;
  var reportData = _objectSpread(_objectSpread({}, getBasicApiTimeData()), {}, {
    // 操作名，一般取接口路径 params为发起xhr 请求时，OPEN方法的所有参数
    actionName: extractPathname(url),
    actionStart: base.start || start,
    // apicall backend tracid
    betraceid: apiCallTraceId,
    // 接口耗时
    elapsed: base.duration || elapsed
  });

  // 接口总时长大于*ms
  if (isPositiveNumber(Config.SLOW_REQUEST_THRESHOLD) && base.duration > Config.SLOW_REQUEST_THRESHOLD) {
    var _getPerformanceResour4 = getPerformanceResourceTiming(fetchResponse.url, start, {
        times: true,
        size: true
      }),
      times = _getPerformanceResour4.times,
      size = _getPerformanceResour4.size;
    Object.assign(reportData, {
      // PerformanceResourceTiming
      prt: JSON.stringify(_objectSpread(_objectSpread(_objectSpread({}, times), size), {}, {
        rtt: base.rtt
      }))
    });
  }

  // http 状态码 200-299
  if (ok) {
    Object.assign(reportData, {
      code: status
    });
  } else {
    Object.assign(reportData, {
      success: false,
      code: status,
      reponse: jsonErr ? '' : JSON.stringify(resData.data),
      request: apiParams.body || JSON.stringify(apiParams.data),
      msg: jsonErr ? jsonErr.message : resData.msg
    });
  }
  timeReport(reportData);
}

/**
 * 拦截fetch接口请求后， 执行自定义的回调
 * @param {Object} fetchResponse fetch接口返回值
 * @param {Object} apiParams fetch 接口的参数
 * @param {number} start 发起请求的起始时间戳
 */
function handleFetch(fetchResponse, apiParams, _ref2) {
  var start = _ref2.start,
    elapsed = _ref2.elapsed;
  // 在 fetchResponse 中的body流没有被使用之前，先克隆一份，否则会报错。
  // 参考 https://developer.mozilla.org/zh-CN/docs/Web/API/Response/clone
  if (fetchResponse instanceof Response) {
    var clonedRes = fetchResponse.clone();
    if (canNotIntercept(clonedRes.url)) {
      return;
    }
    // 异步化，不阻塞后续流程, 降低此日志优先级
    setTimeout(function () {
      if (clonedRes.headers) {
        var contentType = clonedRes.headers.get('Content-Type') || clonedRes.headers.get('content-type');
        var jsonMIME = 'application/json';

        //  目前先处理返回值为 json 的数据
        if (contentType && contentType.includes(jsonMIME)) {
          clonedRes.json().then(function (resData) {
            reportPerfData(clonedRes, apiParams, start, elapsed, resData);
          }, function (jsonerr) {
            reportPerfData(clonedRes, apiParams, start, elapsed, {}, jsonerr);
          });
        }
      }
    }, 0);
  }
}

/**
 * 获取上报的基础性能数据
 *
 * @returns {Object} 性能数据对象
 */
function getBasicApiTimeData() {
  var _ref3;
  // 尽量避免多次获取
  documentWidth = documentWidth || document.documentElement.clientWidth;
  documentHeight = documentHeight || document.documentElement.clientHeight;

  // 要上报的基础数据
  return _ref3 = {
    // 当前页 URL
    url: location.href,
    // 用户的唯一标识，由后端生成写到 cookie 中
    uuid: trackID,
    // 登录用户 id
    uid: getUserID(),
    // 请求类型
    reqType: 'api_call',
    // appid 项目在擎天云节点树上的标识
    appNid: Config.appNid || Config.appId || Config.APPNID
  }, _defineProperty(_ref3, HB_SESSION_ID_KEY, HB_SESSION_ID_VALUE || cookie.get(HB_SESSION_ID_KEY)), _defineProperty(_ref3, "deviceResolution", "".concat(documentWidth, "*").concat(documentHeight)), _defineProperty(_ref3, "success", true), _ref3;
}

// 拦截所有接口请求
export var initInterceptXHR = function initInterceptXHR() {
  var _performance7;
  // 兼容服务端
  // eslint-disable-next-line no-negated-condition
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return;
  }
  if (typeof PerformanceObserver !== 'undefined') {
    var po = new PerformanceObserver(function (list) {
      var _iterator = _createForOfIteratorHelper(list.getEntries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          // const entryJson = entry.toJSON();
          var _ref4 = entry || {},
            initiatorType = _ref4.initiatorType;
          if (initiatorType === 'xmlhttprequest' || initiatorType === 'fetch') {
            requestStack.push(entry);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    po === null || po === void 0 ? void 0 : po.observe({
      entryTypes: ['resource']
    });
  }
  (_performance7 = performance) === null || _performance7 === void 0 ? void 0 : _performance7.addEventListener('resourcetimingbufferfull', clearBufferSize);
  // 重写 xhr 的 open 方法， 拦截所有 api 请求， 统计耗时
  interceptXHR(handleXHR);

  // 重写 fetch 方法， 拦截所有 api 请求， 统计耗时
  interceptFetch(handleFetch);
  // TODO
  // if (Config.ENABLE_QINGZHOU_PERF) {
  // }
};